import { useMemo, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ArrowDown, ArrowUp, ArrowDownUp } from "lucide-react";

interface SortOption {
  key: string;
  label: string;
}

interface Props {
  options: SortOption[];
  value: string;
  direction: "asc" | "desc";
  onChange: (value: string, direction: "asc" | "desc") => void;
}

export default function ResourceSortControl({ options, value, direction, onChange }: Props) {
  const [open, setOpen] = useState(false);

  const active = useMemo(() => {
    return options.find((option) => option.key === value) || options[0];
  }, [options, value]);

  if (!active) return null;

  return (
    <div className="group inline-flex items-center rounded-md bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80">
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="flex h-9 items-center gap-2 px-3 text-sm font-medium text-inherit"
          >
            <ArrowDownUp className="h-4 w-4" />
            <span>{active.label}</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[200px]">
          {options.map((option) => (
            <DropdownMenuItem
              key={option.key}
              onSelect={() => {
                onChange(option.key, direction);
                setOpen(false);
              }}
            >
              {option.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <span className="h-9 w-px bg-secondary-foreground/20" />
      <button
        type="button"
        className="flex h-9 w-9 items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground"
        onClick={() => {
          const next = direction === "asc" ? "desc" : "asc";
          onChange(active.key, next);
        }}
        aria-label={direction === "asc" ? "ترتيب تصاعدي" : "ترتيب تنازلي"}
      >
        {direction === "asc" ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />}
      </button>
    </div>
  );
}
